/* eslint-disable import/prefer-default-export */

// If on these pages, on sign out, go to homepage
const signOutToHomepageRoutes = ['/basket', '/checkout/', '/confirmation/']

export const shouldSignOutToHomepage = (pathname = '') => {
  return signOutToHomepageRoutes.some((route) => pathname.indexOf(route) === 0)
}
